import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import { MUNICIPIO_ADD, MUNICIPIO_ALL, MUNICIPIO_UPDATE, STATES_LIST } from '../../../api/Routes';
import Post from '../../../api/Post';
import Put from '../../../api/Put';
import { authContext } from '../../../context/AuthContext';
import LoadingList from '../../../loader/LoadingList';

import '../../../styles/catalogos/catalogos.css'
import AddMunicipio from './AddMunicipio';
import MunicipioList from './MunicipioList';
import Get from '../../../api/Get';
import ComponentModalErrorSever from '../../../components/ComponentModalErrorSever';

function MunicipioIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({
        dsMunDel:'',
        codMD: '',
        state: ''
    })
    const [loading, setLoading] = useState(false)
    const [loadData, setLoadData] = useState(true)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    const [statesOpt, setStatesOpt] =useState([])
    useEffect(() => {
        Get({url: STATES_LIST, access_token: auth.data.access_token})
        .then((resp) => {
            setStatesOpt(resp.data.data.response)             
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })  
        getAllMunicipios()      
    }, [])

    const getAllMunicipios = () =>{
        setEdit(false)
        setLoading(true)
        Get({url: MUNICIPIO_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            setItems(resp.data.data.response.content)
            setLoading(false)                
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        }) 
    }

    const agregar = (values) => {
        let data = Object.assign({}, values)
        data.active = true;
        data.companies = [auth.data.company]
        data.state = {id: values.state}
        setLoading(true)
        Post({url: MUNICIPIO_ADD, data: data, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //console.log(response)
            setItems(prev=>[...prev, response.data.data])
            setInitialValues({
                dsMunDel:'',
                codMD: '',
                state: ''
            })            
            setLoading(false)  
            
        })                
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })

    }

    const [edit, setEdit] = useState(false)

    const loadToEdit = values =>{
        setInitialValues({
            id: values.id,
            dsMunDel:values.dsMunDel,
            codMD: values.codMD,
            state: values.state.id,
            active: values.active
        })
        setEdit(true)
    }

    const editar = (values) =>{      
        values['companies'] = []
        if(values.active){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        }        
        values.state = {id: values.state}
        
        Put({url: MUNICIPIO_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {            
            setInitialValues({
                dsMunDel:'',
                codMD: '',
                state: ''
            })  
            setLoadData(!loadData)
            getAllMunicipios()      
        })                
        .catch((error) => {                 
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddMunicipio agregar={agregar} initialValues={initialValues} statesOpt={statesOpt} edit={edit} editar={editar}/>}
                </Col>
                <Col xs="6" md="6">
                    <MunicipioList items={items} 
                        editar={editar}
                        auth={auth}
                        loadToEdit={loadToEdit}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default MunicipioIndex